import styled from "styled-components";
import { motion } from "framer-motion";
import BaseTextInput from "_c/form/TextInput";

export const Wrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  img {
    width: 140px;
    min-width: 140px;
  }
  strike {
    display: inline-block;
    opacity: 0.65;
    font-weight: 700;
    color: var(--color-danger);
  }
`;

export const PromocodeInput = motion(styled(BaseTextInput)`
  text-align: center;
  margin-inline-start: 10px;
  padding: 12px 5px;
  border: none;
  // width: 150px;
  ::placeholder {
    color: rgba(0, 0, 0, 0.8);
  }
`);

export const PromoInfoWrap = motion(styled.div`
  text-align: center;
  margin-top: 10px;
`);

export const Icon = styled.img`
  --size: 40px;
  width: var(--size);
  height: var(--size);
  object-fit: cover;
  border-radius: 50%;
  display: inline-block;
`;
export const Desc = styled.p`
  font-size: 14px;
  margin: 0;
  margin-top: 5px;
`;
